/* eslint-disable array-callback-return */
/* eslint-disable func-names */
import React, { useState, useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import withForm from 'modules/common/hoc/withForm';
import { ModalContext } from 'App';
import Modal from 'modules/common/components/Modal';
import DateInputPicker3 from 'modules/common/components/DateInputPicker3';
import * as actions from '../actions';
import * as c from '../constants';

function ChangeQuarter({
  setFormData,
  formData,
  transactionId,
  updating,
  changeQuarter,
  onClear,
  taxPayerInfoIsPosted
}) {
  const setModal = useContext(ModalContext);
  const [isDisabled, setIsDisabled] = useState(true);

  const disableOption = index => { 
    return _.get(taxPayerInfoIsPosted, 'qtr_from') > index ? 'yes' : ''
  }

  const quarterOptions = [
    { label: '1st Quarter', value: '1', disabled: disableOption(1), },
    { label: '2nd Quarter', value: '2', disabled: disableOption(2), },
    { label: '3rd Quarter', value: '3', disabled: disableOption(3), },
    { label: '4th Quarter', value: '4', disabled: disableOption(4), },
  ];

  const getQuarter = () => {
    if (_.get(taxPayerInfoIsPosted, 'qtr_from') === 1) {
      return '1st Quarter';
    }
    if (_.get(taxPayerInfoIsPosted, 'qtr_from') === 2) {
      return '2nd Quarter';
    }
    if (_.get(taxPayerInfoIsPosted, 'qtr_from') === 3) {
      return '3rd Quarter';
    }
    if (_.get(taxPayerInfoIsPosted, 'qtr_from') === 4) {
      return '4th Quarter';
    }
    return '';
  };

  useEffect(() => {
    setFormData({
      ...formData,
      year: _.get(taxPayerInfoIsPosted, 'year') ? _.get(taxPayerInfoIsPosted, 'year').toString() : '',
      qtr_from: _.get(taxPayerInfoIsPosted, 'qtr_from') ? _.get(taxPayerInfoIsPosted, 'qtr_from').toString() : ''
    })
  }, [])
  
  const handleOnChangeSelect = (key) => (e) => {
    setIsDisabled(false);
    setFormData({
      ...formData,
      transaction_history_id: transactionId,
      [key]: e.value ,
    });
  };

  const onChangeYear = key => e => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      qtr_to: _.get(formData, 'qtr_to'),
      year: _.get(formData, 'year')
    };
    changeQuarter(_.omit(args, ['qtr_from']), () => {
      onClear(e);
      setModal({ isOpen: false });
    });
  };

  return (
    <Modal.Body>
      <div className="row">
        <div className="col-12 form-group">
          <label className="form-label d-flex align-items-center">
            <span className="mr-auto mr-0 text-muted">Quarter From</span>
          </label>
          <input
            placeholder=""
            onChange={handleOnChangeSelect('qtr_to')}
            options={quarterOptions}
            value={_.get(formData, 'qtr_from') ? getQuarter(_.get(formData, 'qtr_from')) : ''}
            className="form-control"
            disabled
          />
        </div>
        <div className="col-12 form-group">
          <label className="form-label d-flex align-items-center">
            <span className="mr-auto mr-0 text-muted">Quarter To</span>
          </label>
          <Select
            components={{
              IndicatorSeparator: () => null,
            }}
            onChange={handleOnChangeSelect('qtr_to')}
            options={quarterOptions}
            isOptionDisabled={option => {
              return option.disabled === 'yes'}
            }
            value={
              quarterOptions.find(
                (item) => {
                  return _.get(item, "value") === _.get(formData, "qtr_to")
                }
              ) || ""
            }
          />
        </div>
        <div className="col-12 form-group">
          <label className="form-label d-flex align-items-center">
            <span className="mr-auto mr-0 text-muted">Year</span>
          </label>
          <DateInputPicker3
            showYearPicker
            onChange={onChangeYear('year')}
            className="form-control"
            value={_.get(formData, 'year') || ''}
            placeholder="Select Year..."
            defaultShow={false}
            maxDate={new Date()}
          />
        </div>
        <div className="col-12 d-flex justify-content-center mt-2">
          <button
            disabled={isDisabled || updating}
            onClick={handleSubmit}
            type="button"
            className="btn btn-primary cms-bg-color-primary cms-outline-primary "
          >
            Submit
          </button>
        </div>
      </div>
    </Modal.Body>
  );
}

ChangeQuarter.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  changeQuarter: PropTypes.instanceOf(Object).isRequired,
  transactionId: PropTypes.string.isRequired,
  onClear: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  taxPayerInfoIsPosted: PropTypes.instanceOf(Object).isRequired
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_QUARTER) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ChangeQuarter);
